module.exports = __webpack_public_path__ + "media/images/outlook-icon-f6bd04cca55beb0518ad577b2013acb8.svg";